import { Layout, theme } from 'antd';
import Add from '../../components/Guideaz/Add';
import Footers from '../../components/Footer';
import Headers from '../../components/Header';
import Siders from '../../components/Sider';
import { useNavigate } from 'react-router-dom';
import Tabbar from '../../components/Tabbar';

const { Content } = Layout;

const App = () => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();
    const navigate = useNavigate();
   

    return (
        <Layout
            style={{
                minHeight: '100vh',
            }}
        >
            <Siders />
            <Layout>
                <Headers />
                <Content
                    className="site-layout"
                    style={{
                        padding: '0 10px',
                    }}
                >
                    <div
                       style={{
                            padding: 4,
                            minHeight: 380,
                            background: colorBgContainer,
                        }}
                    >
                        <Add />
                    </div>
                </Content>
                <Tabbar/>
                <Footers />
            </Layout>
        </Layout>
    );
};

export default App;
